export enum ChannelTypeEnum {
  CLOUD_API = "CLOUD_API",
  INTEGRATIONS_API = "INTEGRATIONS_API",
  Z_API = "Z_API",
  INSTAGRAM_API = "INSTAGRAM_API",
  MESSENGER_API = "MESSENGER_API",
  RCS_API = "RCS_API",
  VOIP_API = "VOIP_API",
  WEBCHAT_API = "WEBCHAT_API",
}